import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  useToast,
  Flex,
} from '@chakra-ui/react';
import FaqApi from 'api/faq';
import { useAuth } from '../../../../auth-context/auth.context';
import TextAreaField from 'components/formComponents/textAreaField';
import SelectField from 'components/formComponents/selectField';
import InputField from 'components/formComponents/inputField.js';
import { FaqValidationSchema } from 'formValidations/faqFormValidations';

export default function PopModal(props) {
  const currentFaq = props.currentFaq;
  const faqId = currentFaq.id;
  const { user } = useAuth();
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);

  const initialValues = {
    question: currentFaq.question,
    answer: currentFaq.answer,
    isActive: currentFaq.is_active,
    displayOrder: currentFaq.display_order,
    language_code: currentFaq.language_code
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    console.log('values for faq edit', values);
    try {
      let response = await FaqApi.Update({
        faqId,
        ...values,
      });
      response = response.data;
      if (response.status_code === 200) {
        toast({
          title: response?.data?.message || 'Successfully edited',
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
        onClose();
        props.func();
      } else {
        toast({
          title: response?.data?.message || 'Error Adding',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (error) {
      toast({
        title: 'Unable to Add',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
      console.log(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Button onClick={onOpen} disabled={props.disabled}>
        {props.Icon}
      </Button>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{props.head}</ModalHeader>
          <ModalCloseButton />
          <Formik
            initialValues={initialValues}
            validationSchema={FaqValidationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form noValidate>
                <ModalBody pb={6}>
                  <TextAreaField
                    label='Question'
                    name='question'
                    placeholder='Upto 200 Characters'
                  />
                  <TextAreaField
                    label='Answer'
                    name='answer'
                    placeholder='Upto 400 Characters'
                    mt={4}
                  />
                  <SelectField
                    label='Status'
                    name='isActive'
                    options={[
                      { value: true, label: 'Active' },
                      { value: false, label: 'Inactive' },
                    ]}
                    mt={4}
                  />
                  <SelectField
                    label='Language'
                    name='language_code'
                    options={[
                      { value: 'en', label: 'English' },
                      { value: 'kn', label: 'Kannada' },
                    ]}
                    mt={4}
                  />
                  <InputField
                    name='displayOrder'
                    label='Display Order'
                    type='number'
                    placeholder='Enter Display Order'
                    required
                  />
                </ModalBody>
                <ModalFooter>
                  <Button
                    colorScheme='blue'
                    mr={3}
                    type='submit'
                    isLoading={isSubmitting}
                  >
                    Save
                  </Button>
                  <Button onClick={onClose}>Cancel</Button>
                </ModalFooter>
              </Form>
            )}
          </Formik>
        </ModalContent>
      </Modal>
    </>
  );
}
